import { OFFLINE_CAP_SECONDS, SAVE_KEY } from "@/game/data/constants";
import { recomputeRates } from "@/game/model/balance";
import { createInitialIdleState, type IdleState } from "@/game/model/idle-state";
import { applyIdleTick } from "@/game/systems/idle-tick";

export type PersistedSave = IdleState;

export function loadIdleState(now = Date.now()): {
  state: IdleState;
  offlineSeconds: number;
} {
  const raw = localStorage.getItem(SAVE_KEY);
  if (!raw) {
    return { state: createInitialIdleState(now), offlineSeconds: 0 };
  }

  try {
    const parsed = JSON.parse(raw) as PersistedSave;
    const base = recomputeRates({ ...createInitialIdleState(parsed.createdAt), ...parsed });
    const elapsedMs = Math.max(0, now - base.lastTickAt);
    const offlineSeconds = Math.min(OFFLINE_CAP_SECONDS, elapsedMs / 1000);
    const { state } = applyIdleTick(base, offlineSeconds);
    return { state: { ...state, lastTickAt: now }, offlineSeconds };
  } catch {
    localStorage.removeItem(SAVE_KEY);
    return { state: createInitialIdleState(now), offlineSeconds: 0 };
  }
}

export function saveIdleState(state: IdleState, now = Date.now()): void {
  const payload: PersistedSave = { ...state, lastTickAt: now };
  localStorage.setItem(SAVE_KEY, JSON.stringify(payload));
}
